import { routes } from "~/app/routes/web-routes.ts";
import { useCustomerSelection } from "~/shared/hooks/use-customer-selection.ts";

export const useReportNavigation = (reportId: string) => {
	return useCustomerSelection({
		baseRoute: routes.reportsWithId.replace(":reportId", reportId),
		customerRoute: routes.reportsWithIdAndCustomer.replace(
			":reportId",
			reportId,
		),
	});
};
